import React from 'react';

import Text from 'v3/components/Text';

import {
  Container,
  SubContainer,
  BoxContainer,
  StatusBadge,
} from './styles';

function StatusColor() {
  return (
    <Container>
      <SubContainer>
        <BoxContainer>
          <StatusBadge $variant="origin">A</StatusBadge>
          <Text weight="400" type="label" color="gray">
            Origem
          </Text>
        </BoxContainer>

        <BoxContainer>
          <StatusBadge $variant="destination">B</StatusBadge>
          <Text weight="400" type="label" color="gray">
            Destino
          </Text>
        </BoxContainer>

        <BoxContainer>
          <StatusBadge $variant="final">C</StatusBadge>
          <Text weight="400" type="label" color="gray">
            Destino Final
          </Text>
        </BoxContainer>
      </SubContainer>
    </Container>
  );
}

export default StatusColor;
